$(document).ready(function () {
  $('.ResponsiveCarousel').owlCarousel({
    margin: 24,
    autoWidth: true,
    items: 2,
    responsiveClass: true,
    rtl: true,
  });

  var productSlider = $('.products').owlCarousel({
    loop: true,
    items: 4,
    margin: 24,
    responsiveClass: true,
    rtl: true,
    nav: false,
    dots: false,
    responsive: {
      320: {
        items: 1,
      },
      420: {
        items: 1.5,
      },
      768: {
        items: 2,
      },
      992: {
        items: 3,
      },
      1200: {
        items: 4,
      },
    },
  });

  $(".custom-product-nav-next").click(function () {
    productSlider.trigger('next.owl.carousel');
  });

  $(".custom-product-nav-prev").click(function () {
    productSlider.trigger('prev.owl.carousel');
  });

  var dotContainer = jQuery('.product-dots-class-container');

  dotContainer.empty();

  productSlider.find('.owl-item:not(.cloned)').each(function (index) {
    dotContainer.append('<div class="custom-dot-class" data-index="' + index + '"></div>');
  });

  productSlider.on('changed.owl.carousel', function (event) {
    var totalItems = productSlider.find('.owl-item:not(.cloned)').length;
    var currentIndex = event.item.index % totalItems;
    jQuery('.custom-dot-class').removeClass('active');
    jQuery('.custom-dot-class[data-index="' + currentIndex + '"]').addClass('active');
  });

  jQuery('.product-dots-class-container').on('click', '.custom-dot-class', function () {
    var index = jQuery(this).data('index');
    productSlider.trigger('to.owl.carousel', [index, 300]);
  });

  jQuery('.custom-dot-class').first().addClass('active');

});
$('.teams').owlCarousel({
  loop: false,
  items: 3,
  margin: 24,
  responsiveClass: true,
  rtl: true,
  nav: false,
  dots: false,
  responsive: {
    320: {
      items: 1,
      nav: true
    },
    576: {
      items: 2,
      nav: false
    },
    768: {
      items: 4,
      nav: false
    },
  },
});
$('.conference-slide').owlCarousel({
  loop: false,
  items: 3,
  margin: 24,
  responsiveClass: true,
  rtl: true,
  nav: false,
  responsive: {
    320: {
      items: 1,
      nav: true
    },
    576: {
      items: 2,
      nav: false
    },
    992: {
      items: 3,
      nav: false
    },
  },
});

$('.support-first').owlCarousel({
  loop: false,
  items: 3,
  margin: 24,
  responsiveClass: true,
  rtl: true,
  nav: false,
  dots: false,
  responsive: {
    320: {
      items: 1,
      nav: true
    },
    576: {
      items: 2,
      nav: false
    },
    768: {
      items: 4,
      nav: false
    },
  },
});
$('.support-second').owlCarousel({
  loop: false,
  items: 3,
  margin: 24,
  responsiveClass: true,
  rtl: true,
  nav: false,
  dots: false,
  responsive: {
    320: {
      items: 1,
      nav: true
    },
    576: {
      items: 2,
      nav: false
    },
    768: {
      items: 4,
      nav: false
    },
  },
});
$(document).ready(function () {
  $('.subscription').owlCarousel({
    loop: false,
    margin: 10,
    responsiveClass: true,
    rtl: true,
    nav: false,
    dots: false,
    responsive: {
      320: {
        items: 1,
        nav: true
      },
      768: {
        items: 2,
        nav: false
      },
      992: {
        items: 3,
        nav: false
      },
      1200: {
        items: 3,
        nav: false
      },
      1400: {
        items: 4,
        nav: false
      },
    },
  });

  $(".birthdate").persianDatepicker({
    format: 'YYYY/MM/DD',
    autoClose: true,
    initialValue: false,
    maxDate: new persianDate().subtract('years', 18).format('YYYY/MM/DD'),
    calendarPosition: 'auto'
  });

  $('#selectImage').on('click', function () {
    $('#uploadImage').click();
  });

  $('#uploadImage').on('change', function () {
    const fileName = $('#fileName');
    const fileInput = $(this);
    fileName.text(fileInput[0].files.length > 0 ? fileInput[0].files[0].name : 'انتخاب کنید');
  });

  jQuery('.increase-product').on('click', function () {
    var $counter = jQuery(this).siblings('.product-count-number');
    var currentValue = parseInt($counter.text());
    $counter.text(currentValue + 1);
  });
  jQuery('.decrease-product').on('click', function () {
    var $counter = jQuery(this).siblings('.product-count-number');
    var currentValue = parseInt($counter.text());
    if (currentValue > 1) {
      $counter.text(currentValue - 1);
    }
  });
});
$(document).ready(function () {
  $('.subscription').owlCarousel({
    loop: false,
    margin: 10,
    responsiveClass: true,
    rtl: true,
    nav: false,
    dots: false,
    responsive: {
      320: {
        items: 1,
        nav: true
      },
      768: {
        items: 2,
        nav: false
      },
      992: {
        items: 3,
        nav: false
      },
      1200: {
        items: 3,
        nav: false
      },
      1400: {
        items: 4,
        nav: false
      },
      1700: {
        items: 5,
        nav: false
      },
    },
  });

  $(function () {
    $('.player-video').each(function () {
      const player = new Plyr(this, {
        hideControls: true,
        controls: ['progress', 'current-time', 'mute', 'volume', 'fullscreen'],
      });

      const plyrId = $(this).data('plyr');
      const $customPlayBtn = $(`.custom-play[data-plyr="${plyrId}"]`);

      $customPlayBtn.on('click', function () {
        if (player.playing) {
          player.pause();
        } else {
          player.play();
        }
      });

      player.on('play', function () {
        $customPlayBtn.hide();
      });

      player.on('pause', function () {
        $customPlayBtn.show();
      });
    });
  });


  $('.share-btn').on('click', function () {
    const pageUrl = window.location.href;
    navigator.clipboard.writeText(pageUrl).then(function () {
      alert('آدرس صفحه کپی شد!');
    })
  });


  $('.comment-box .like-btn').on('click', function () {
    var comment = $(this).closest('.comment-box');
    comment.find('.dislike-btn').removeClass('active');
    $(this).toggleClass('active');
  });

  $('.comment-box .dislike-btn').on('click', function () {
    var comment = $(this).closest('.comment-box');
    comment.find('.like-btn').removeClass('active');
    $(this).toggleClass('active');
  });

  $('.like-bread').on('click', function () {
    var likeBtn = $('.like-bread');
    likeBtn.toggleClass('active');
  });


  $('.like-bar-btn').on('click', function () {
    $('.dislike-bar-btn').removeClass('active');
    $(this).toggleClass('active');
  });

  $('.dislike-bar-btn').on('click', function () {
    $('.like-bar-btn').removeClass('active');
    $(this).toggleClass('active');
  });

});
$(document).ready(function () {
  var trainingSlider = $('.training-way').owlCarousel({
    loop: true,
    items: 3,
    margin: 24,
    responsiveClass: true,
    rtl: true,
    nav: false,
    dots: false,
    responsive: {
      320: {
        items: 1,
      },
      420: {
        items: 1.5,
      },
      768: {
        items: 2,
      },
      1400: {
        items: 3,
      },
    },
  });

  $(".custom-training-nav-next").click(function () {
    trainingSlider.trigger('next.owl.carousel');
  });

  $(".custom-training-nav-prev").click(function () {
    trainingSlider.trigger('prev.owl.carousel');
  });

  var dotContainer = jQuery('.training-dots-class-container');

  dotContainer.empty();

  trainingSlider.find('.owl-item:not(.cloned)').each(function (index) {
    dotContainer.append('<div class="custom-dot-class" data-index="' + index + '"></div>');
  });

  trainingSlider.on('changed.owl.carousel', function (event) {
    var totalItems = trainingSlider.find('.owl-item:not(.cloned)').length;
    var currentIndex = event.item.index % totalItems;
    jQuery('.custom-dot-class').removeClass('active');
    jQuery('.custom-dot-class[data-index="' + currentIndex + '"]').addClass('active');
  });

  jQuery('.training-dots-class-container').on('click', '.custom-dot-class', function () {
    var index = jQuery(this).data('index');
    trainingSlider.trigger('to.owl.carousel', [index, 300]);
  });

  jQuery('.custom-dot-class').first().addClass('active');

});
$(document).ready(function () {
  $('.category-last-course').owlCarousel({
    loop: false,
    margin: 10,
    responsiveClass: true,
    rtl: true,
    nav: false,
    dots: false,
    responsive: {
      320: {
        items: 2,
        nav: false
      },
      420: {
        items: 3.5,
        nav: false
      },
      768: {
        items: 6,
        nav: false
      },
      1200: {
        items: 10,
        nav: false
      },
    },
  });
});
$(document).ready(function () {
  $('.last-course').owlCarousel({
    loop: true,
    margin: 10,
    responsiveClass: true,
    rtl: true,
    nav: false,
    dots: false,
    responsive: {
      320: {
        items: 1,
        nav: false
      },
      420: {
        items: 1.5,
        nav: false
      },
      768: {
        items: 2,
        nav: false
      },
      992: {
        items: 2.5,
        nav: false
      },
    },
  });
});
$(document).ready(function () {

  $('.start-conversation').on('click', function () {
    Goftino.open();
  })
  $('.best-course').owlCarousel({
    loop: true,
    margin: 10,
    responsiveClass: true,
    rtl: true,
    nav: false,
    dots: false,
    responsive: {
      320: {
        items: 1,
        nav: false
      },
      420: {
        items: 1.5,
        nav: false
      },
      768: {
        items: 2,
        nav: false
      },
      992: {
        items: 3,
        nav: false
      },
      1200: {
        items: 4,
        nav: false
      },
    },
  });
});
new Swiper(".mySwiper", {
  effect: "coverflow",
  grabCursor: true,
  centeredSlides: true,
  slidesPerView: "auto",
  spaceBetween: 0,
  loop: true,
  loopedSlides: 8,
  coverflowEffect: {
    rotate: 200,
    depth: -800,
    modifier: .1,
    scale: 0.2,
    slideShadows: false
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  responsive: {
    320: {
      items: 1,
      nav: true
    },
    768: {
      items: 2,
      nav: true
    },
    992: {
      items: 3,
      nav: true
    },
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },

});

jQuery('.copy-license-clip').on('click', function (e) {
  e.preventDefault();
  var spanText = jQuery(this).find('span').text();

  var tempInput = jQuery('<input>');
  jQuery('body').append(tempInput);
  tempInput.val(spanText).select();
  document.execCommand('copy');
  tempInput.remove();
  alert('متن با موفقیت کپی شد: ' + spanText);
});

$('.conference-video ').on('click', function () {
  $('.conference-title').toggleClass('hidden');
});

$('.object-license img').on('click', function () {
  var primaryUrl = $(this).attr('src');
  $('.object-license-primary-image').attr('src', primaryUrl);
});


$('#a-plan').show();
$('#b-plan').hide();
$('.a-plan').addClass('text-myblue border-myblue');
$('.a-plan').on('click', function () {
  $('#a-plan').show();
  $('#b-plan').hide();
  $(this).addClass('text-myblue border-myblue');
  $('.b-plan').removeClass('text-myblue border-myblue');
});

$('.b-plan').on('click', function () {
  $('#b-plan').show();
  $('#a-plan').hide();
  $(this).addClass('text-myblue border-myblue');
  $('.a-plan').removeClass('text-myblue border-myblue');
});


$('.filter-list').hide();
$('.filter-button').on('click', function (e) {
  e.stopPropagation();
  $('.filter-list').toggle();
});


$(document).on('click', function (e) {
  if (!$(e.target).closest('.filter-list, .filter-button').length) {
    $('.filter-list').hide();
  }

});
jQuery(document).ready(function () {
  $(document).on('click', function (e) {
    var $dropdown = $('#categoryDropdown');
    var $button = $('#categoryDropdownButton');

    if (!$button.is(e.target) && !$button.has(e.target).length &&
      !$dropdown.is(e.target) && !$dropdown.has(e.target).length) {
      $dropdown.addClass('hidden');
    }
  });

  $('#categoryDropdownButton').on('click', function (e) {
    e.stopPropagation();
    $('#categoryDropdown').toggleClass('hidden');
  });

  $('#categoryDropdown a').on('click', function(e) {
    e.preventDefault();
    var selectedCategoryName = $(this).data('category-name');
    var selectedCategoryId = $(this).data('category-id');

    $('#selectedCategoryName').text(selectedCategoryName);
    $('#selectedCategory').val(selectedCategoryId);

    $('#categoryDropdown').addClass('hidden');
  });

  $('.popup-image').magnificPopup({
    type: 'image',
    gallery: {
      enabled: true
    }
  });
  var header = jQuery('.header-menu').first();
  var headerOffset = header.offset().top;

  jQuery(window).scroll(function () {
    if (jQuery(window).scrollTop() > headerOffset) {
      header.addClass('fixed top-0 w-full z-50 bg-white shadow-md');
    } else {
      header.removeClass('fixed top-0 w-full z-50 bg-white shadow-md');
    }
  });

  jQuery('.submenu-toggle').on('click', function (e) {
    e.preventDefault();
    var $submenu = jQuery(this).next('.submenu');

    if ($submenu.hasClass('hidden')) {
      jQuery('.submenu').addClass('hidden');
      $submenu.removeClass('hidden');
    } else {
      $submenu.addClass('hidden');
    }
  });

  jQuery(document).on('click', function (e) {
    if (!jQuery(e.target).closest('.submenu-toggle').length) {
      jQuery('.submenu').addClass('hidden');
    }
  });
  var sidebar = new StickySidebar('.sticky-sidebar', {
    topSpacing: 20,
    bottomSpacing: 0,
    containerSelector: '.content',
    innerWrapperSelector: '.sidebar__inner',
    resizeSensor: true,
  });


});
